'use client';

import NumberField from '@koda/koda-components/molecules/NumberField';
import { RadioGroup } from '@koda/koda-components/molecules/RadioGroup';
import TextField from '@koda/koda-components/molecules/TextField';
import { useTranslations } from 'next-intl';
import { ReactElement } from 'react';
import { LicenseTypes } from '../../../types/licenses';
import { useLicenseBusiness } from '../hooks/useLicenseBusiness';
import {
  BACKGROUND_THEATER_CONTENT_PATH,
  backgroundTheaterSchema,
  createBackgroundTheaterDefaults,
} from './backgroundTheater.Schema';

export default function BackgroundTheaterComponent(): ReactElement {
  const licenseCode = LicenseTypes.BackgroundTheater;

  const { values, setField, getError, costCalculated, showErrors } = useLicenseBusiness(licenseCode, {
    schema: backgroundTheaterSchema,
    defaults: createBackgroundTheaterDefaults,
  });

  const t = useTranslations(BACKGROUND_THEATER_CONTENT_PATH);

  return (
    <>
      <TextField
        type="text"
        styleVariant="border"
        label={t('theaterName.label')}
        placeholder={t('theaterName.placeholder')}
        required
        disabled={costCalculated}
        value={values.theaterName ?? ''}
        onChange={e => setField('theaterName', e.target.value)}
        error={values.theaterName || showErrors ? getError('theaterName') : undefined}
        validated={!!values.theaterName && !getError('theaterName')}
      />
      <NumberField
        label={t('seatCount.label')}
        name="seatCount"
        placeholder={t('seatCount.placeholder')}
        required
        disabled={costCalculated}
        value={values.seatCount}
        onChange={e => setField('seatCount', parseInt(e.target.value))}
        error={values.seatCount || showErrors ? getError('seatCount') : undefined}
        validated={!!values.seatCount && !getError('seatCount')}
        min={1}
        sign="positive-only"
        styleVariant="border"
      />
      <RadioGroup
        title={t('hasFixedVenue.label')}
        options={[
          { value: 'true', label: t('hasFixedVenue.options.yes') },
          { value: 'false', label: t('hasFixedVenue.options.no') },
        ]}
        disabled={costCalculated}
        horizontal={true}
        value={values.hasFixedVenue === null ? undefined : values.hasFixedVenue ? 'true' : 'false'}
        onValueChange={val => setField('hasFixedVenue', val === 'true')}
        error={showErrors ? getError('hasFixedVenue') : undefined}
      />
    </>
  );
}
